// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-banner {
    position: relative;
}

.page-banner__picture {
    width: 100%;
    height: auto;
    z-index: 0;
}

.page-banner__wrap {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.page-banner__h1 {
    font-size: var(--font-xl);
    color: var(--color-white);
    padding: 30px;
    margin: 30px;
    background-color: rgba(100, 100, 100, 0.6);
    border-radius: 10px;
    text-align: center;
}

.page-content {
    padding: 0 15px;
    width: 960px;
    max-width: 100%;
    margin: 0 auto;
    margin-top: var(--block-margin-y);
    margin-bottom: var(--block-margin-y);
    box-sizing: border-box;
}

.page-content__block {
    margin: 30px 0;
    text-align: justify;
}

.page-content__h2 {
    margin-bottom: 30px;
    padding: 0 0;
    font-size: var(--font-l);
}
.page-content__h3 {
    margin-bottom: 30px;
    padding: 0 0;
    font-size: var(--font-m);
}

.page-content__h1 {
    margin-bottom: 30px;
    padding: 0 0;
    font-size: var(--font-xl);
}
.page-content__button{
    color:#ffffff;
    background-color: var(--color-main);
    display: inline-block;
    border-radius: 10px;
    padding:15px 25px;
    text-transform: uppercase;
    cursor: pointer;
    outline: none !important;
    text-decoration: none !important;
}
.page-content__list {
    margin: 0;
    margin-left: 20px;
    padding-left: 24px;
    list-style-type: disc;
}

ol.page-content__list > li {
    margin: 15px 0;
    list-style-type: decimal;
}

ul.page-content__list > li {
    margin: 15px 0;
    list-style-type: circle;
}

.page-block-2 {
    display: flex;
    flex-direction: row;
    justify-content: stretch;
}

.page-block-2-1 {
    flex: 1 1 50%;
    order: 2;
}

.page-block-2__picture {
    object-fit: contain;
    width: 100%;
    height: auto;
}

.page-block-2__picture > img {
    object-fit: contain;
    width: 100%;
    height: auto;
}

.page-block-2-2 {
    flex: 1 1 50%;
    order: 2;
}

.page-block-2__text {
    padding: 0 15px;
    margin-bottom: 30px;
}

.page-block-2__h2 {
    padding: 0 15px;
    margin-bottom: 30px;
    margin-top: 0;
}


@media screen and (max-width: 1024px) {
    .page-block-2 {
        flex-direction: column;
    }

    .page-block-2__text {
        padding: 15px 0;
    }

    .page-block-2__first {
        order: 1;
    }

    .page-block-2__h2 {
        margin-bottom: 30px;
        margin-top: 15px;
    }

    .page-content__h2 {
        margin-bottom: 30px;
        padding: 0;
        font-size: var(--font-l);
    }

    .page-content__h1 {
        margin-bottom: 30px;
        padding: 0 0;
        font-size: var(--font-xl);
    }
}
`, "",{"version":3,"sources":["webpack://./resources/views/site/pages/page/main.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf,cAAc;IACd,iCAAiC;IACjC,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,wBAAwB;AAC5B;AACA;IACI,mBAAmB;IACnB,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,mCAAmC;IACnC,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;IACf,wBAAwB;IACxB,gCAAgC;AACpC;AACA;IACI,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,aAAa;AACjB;;;AAGA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,UAAU;QACV,wBAAwB;IAC5B;;IAEA;QACI,mBAAmB;QACnB,YAAY;QACZ,yBAAyB;IAC7B;AACJ","sourcesContent":[".page-banner {\n    position: relative;\n}\n\n.page-banner__picture {\n    width: 100%;\n    height: auto;\n    z-index: 0;\n}\n\n.page-banner__wrap {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.page-banner__h1 {\n    font-size: var(--font-xl);\n    color: var(--color-white);\n    padding: 30px;\n    margin: 30px;\n    background-color: rgba(100, 100, 100, 0.6);\n    border-radius: 10px;\n    text-align: center;\n}\n\n.page-content {\n    padding: 0 15px;\n    width: 960px;\n    max-width: 100%;\n    margin: 0 auto;\n    margin-top: var(--block-margin-y);\n    margin-bottom: var(--block-margin-y);\n    box-sizing: border-box;\n}\n\n.page-content__block {\n    margin: 30px 0;\n    text-align: justify;\n}\n\n.page-content__h2 {\n    margin-bottom: 30px;\n    padding: 0 0;\n    font-size: var(--font-l);\n}\n.page-content__h3 {\n    margin-bottom: 30px;\n    padding: 0 0;\n    font-size: var(--font-m);\n}\n\n.page-content__h1 {\n    margin-bottom: 30px;\n    padding: 0 0;\n    font-size: var(--font-xl);\n}\n.page-content__button{\n    color:#ffffff;\n    background-color: var(--color-main);\n    display: inline-block;\n    border-radius: 10px;\n    padding:15px 25px;\n    text-transform: uppercase;\n    cursor: pointer;\n    outline: none !important;\n    text-decoration: none !important;\n}\n.page-content__list {\n    margin: 0;\n    margin-left: 20px;\n    padding-left: 24px;\n    list-style-type: disc;\n}\n\nol.page-content__list > li {\n    margin: 15px 0;\n    list-style-type: decimal;\n}\n\nul.page-content__list > li {\n    margin: 15px 0;\n    list-style-type: circle;\n}\n\n.page-block-2 {\n    display: flex;\n    flex-direction: row;\n    justify-content: stretch;\n}\n\n.page-block-2-1 {\n    flex: 1 1 50%;\n    order: 2;\n}\n\n.page-block-2__picture {\n    object-fit: contain;\n    width: 100%;\n    height: auto;\n}\n\n.page-block-2__picture > img {\n    object-fit: contain;\n    width: 100%;\n    height: auto;\n}\n\n.page-block-2-2 {\n    flex: 1 1 50%;\n    order: 2;\n}\n\n.page-block-2__text {\n    padding: 0 15px;\n    margin-bottom: 30px;\n}\n\n.page-block-2__h2 {\n    padding: 0 15px;\n    margin-bottom: 30px;\n    margin-top: 0;\n}\n\n\n@media screen and (max-width: 1024px) {\n    .page-block-2 {\n        flex-direction: column;\n    }\n\n    .page-block-2__text {\n        padding: 15px 0;\n    }\n\n    .page-block-2__first {\n        order: 1;\n    }\n\n    .page-block-2__h2 {\n        margin-bottom: 30px;\n        margin-top: 15px;\n    }\n\n    .page-content__h2 {\n        margin-bottom: 30px;\n        padding: 0;\n        font-size: var(--font-l);\n    }\n\n    .page-content__h1 {\n        margin-bottom: 30px;\n        padding: 0 0;\n        font-size: var(--font-xl);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
